<template>
  <div class="content">
    <div class="top" style="display: flex;justify-content: space-between;">
      <div style="width:100%;max-width:1200px;margin:0px auto;">
        <div>
          <router-link :to="{name:'Common_product'}"><img src="../assets/back.png" style="position: absolute;width: 8%;top: 10px;left: 10px;"></router-link>
        </div>
        <div class="logo">
          <router-link to='/'><img src="../assets/logo.png"></router-link>
        </div>
      </div>
    </div>
    <div class="w">
      <div class="title"><span>投诉建议</span></div>
      <div class="report">
        <div class="item">
          <span class="name">姓名</span></br>
          <input class="baseInput" id="username" type="text" required placeholder="姓名(必填)" v-model="username" @keyup="verify"/>
          <span style="color: red" id="s_name" class="error">{{s_name}}</span>
        </div>
        <div class="item">
          <span class="name">手机号码</span></br>
          <input class="baseInput" maxlength="11" id="mobile" type="text" placeholder="手机号码(必填)" v-model="mobile" @keyup="verify"/>
          <span style="color: red" id="s_mobile" class="error">{{s_mobile}}</span>
        </div>
        <div class="item">
          <span class="name">内容</span></br>
          <textarea class="baseInput" id="content" placeholder="内容(必填)" style="line-height: 18px;height: 80px;" v-model="content" @keyup="verify"></textarea>
          <span style="color: red" id="s_content" class="error">{{s_content}}</span>
        </div>
        <div class="item">
          <span class="name" id="item">投诉建议的产品图片</span>
          <div class="upload">
           <div>
              <img v-for="(item,index) in base64Imgs" :src="item" class="baseImg" @click="imgRemove(index)"/>
              <a href="javascript:;" class="add" id="add"><input type="file" id="file_input" multiple @change="readFile"/></a>
           </div>
            <p class="tips">文件不超过2M，格式支持：*.gif; *.jpg; *.png; *.bmp; *.jpeg</p>
          </div>
        </div>
        <div class="item">
          <span class="name" style="float: left;">验证码</span>
          <div style="width: 100%;float: left;">
            <input class="baseInput code" id="code" type="text" placeholder="" maxlength="4" v-model="code" @keyup="verify"/>
            <a href="javascript:;" @click="codeImg">
              <span class="code-img" id="codeImg" :style="{backgroundImage:'url('+codeUrl+')'}"></span>
            </a>
            <a href="javascript:;" @click="codeImg" style="font-size: 10px;line-height: 4;">看不清换一张</a>
            </br><span style="color: red" id="s_code" class="error">{{s_code}}</span>
          </div>
        </div>
        <div class="submit" style="max-width: 335px;">
          <button type="button" id="putIn" @click="post">提交投诉建议</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveComplaininfo } from "@/api/api";
import cpFooter from '@/views/footer';
export default {
  name: 'Complain_info',
  components: {
    cpFooter
  },
  data() {
    return {
      codeUrl:"",
      orgId:0,
      orgName:"",
      pname:"",
      s_name:"",
      s_mobile:"",
      s_content:"",
      s_code:"",
      username:"",
      mobile:"",
      content:"",
      code:"",
      base64Imgs:[],
      imgData: {
        accept: 'image/gif, image/jpeg, image/png, image/jpg, image/bmp',
      },
      randomStr:""
    }

  },
  watch: {

  },
  created() {
    this.codeImg();
    this.num = localStorage.getItem("zymCode");
    this.getList();
  },
  methods: {
    imgRemove(index){
      this.base64Imgs.splice(index,1);
    },
    readFile(e){
      let that = this;
      let reader = new FileReader();
      let file = event.target.files;
      var iLen = file.length;
      for(var i = 0; i < iLen; i++){
        let type = file[i].type; //文件的类型，判断是否是图片
        let size = file[i].size; //文件的大小，判断图片的大小
        if(that.imgData.accept.indexOf(type) == -1) {
        	that.$Message.error('上传的图片格式不正确，请重新选择！');
        	return false;
        }
        if (size > 2097152) {
        	that.$Message.error('请选择2M以内的图片！');
        	return false;
        }
        let reader = new FileReader();
        reader.readAsDataURL(file[i]);  //转成base64
        reader.fileName = file[i].name;
        reader.onload = function (e) {
          that.base64Imgs.push(e.target.result);
        }
      }
    },
    remove(){
      this.username = "";
      this.mobile = "";
      this.content = "";
      this.base64Imgs = [];
      this.code = "";
    },
    post() {
      if(!this.username){
        this.s_name = "姓名格式错误,请重新输入!";
      }else if(!this.mobile){
        this.s_mobile = "手机号码格式错误,请重新输入!";
      }else if(!this.content){
        this.s_content = "内容为5-200长度的字符,您输入的格式有误,请重新输入!";
      }else if(!this.code){
        this.s_code = "验证码不能为空，请输入验证码！";
      }else{
        let parmas = {
          areaId: this.orgId,
          sysSource: "06",
          username: this.username,
          mobile: this.mobile,
          companyName: this.orgName,
          productName: this.pname,
          content: this.content,
          base64Imgs: this.base64Imgs,
          code: this.code,
          randomStr: this.randomStr
        };
        saveComplaininfo(parmas).then(res => {
          console.log(res)
          if (res.data.code == 0) {
            this.$Message.success('我们会尽管处理您的投诉内容，给您带来的不便敬请谅解！');
            this.remove();//清除表单内容
          } else if (res.data.msg == "验证码不能为空") {
            this.$Message.warning('验证码不能为空，请输入验证码！');
          } else if (res.data.msg == "验证码不合法") {
            this.$Message.warning('您输入的验证码不合法，请重新输入！');
          }else{
            this.$Message.error('网络异常,请稍后再试！');
          }
          this.codeImg();//刷新验证码
        });
      }
    },
    verify(){
      if(this.username){
        this.s_name = "";
      }
      if(this.mobile){
        this.s_mobile = "";
      }
      if(this.content){
        this.s_content = "";
      }
      if(this.code){
        this.s_code = "";
      }
    },
    codeImg() {
      this.randomStr = new Date().getTime();
      var code = "http://gateway.zhenyuanma.com/code?randomStr=" + this.randomStr;
      this.codeUrl = code;
      console.log(this.codeUrl)
    },
    getList() {
      this.$axios({
        method: "get",
        url: "portal/suyuan/getCompanyInfo/" + this.num
      }).then(res => {
        this.orgName = res.data.data.orgName;
        this.orgId = res.data.data.orgId;
      }).catch(err => {});

      this.$axios({
        method: 'get',
        url: 'portal/suyuan/getProductInfo/' + this.num
      }).then(res => {
          this.pname = res.data.data.pname;
      }).catch(err => {});
    }
  }
};
</script>

<style>
.error{
  font-size: 10px;
}

.top {
  height: 3rem;
  background-color: #45b035;
}

.logo {
  width: 25%;
  margin:0px auto;
  line-height: 3rem;
}

.logo > a{
  display: inline-block;
  margin-top:10%;
}
.logo img {
  display: block;
  width: 100%;
}

.content {
    /* margin-top: 40px;
    margin-left: 20px;
    margin-right: 20px; */
}

.w {
  /* width: 95%; */
  margin-top: 5px;
  margin-left: 20px;
  margin-right: 20px;
}

.content .title {
  position: relative;
  font-size: 18px;
  color: #333;
  height: 40px;
  line-height: 40px;
  /* margin-top: 40px; */
  border-bottom: 2px solid #f5f5f5;
}

.content .title:before {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 72px;
  height: 2px;
  background-color: #45b035;
}

input,
textarea,
div {
  resize: none;
  outline: none;
  font-size: inherit;
  font-family: inherit;
}

.content .report .item {
  overflow: hidden;
  margin: 10px auto;
}

.content .report .item .name {
  display: inline-block;
/*  float: left; */
  margin-right: 20px;
  /* width: 112px; */
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #666;
  text-align: left;
}

.content .report .item .baseInput {
  width: 100%;
  max-width: 335px;
  padding: 0 10px;
  height: 40px;
  line-height: 40px;
  color: #333;
  font-size: 14px;
  outline: none;
  border: 1px solid #f2f2f2;
}

.content .report .item .code {
  float: left;
  width: 100px;
}

.content .report .submit button {
  display: inline-block;
  width: 100%;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  text-align: center;
  color: #fff;
  background-color: #45b035;
  cursor: pointer;
}

.content .report .item .upload a.add {
  display: block;
  float: left;
    position: relative;
   overflow: hidden;
    margin:0px 10px 10px 0px;
    width: 98px;
    height: 98px;
    border: 1px solid #e3e3e3;
}

.content .report .item .upload .baseImg{
  float: left;
    margin:0px 10px 10px 0px;
    width: 98px;
    height: 98px;
}

.content .report .item .upload a.add input {
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
}

.content .report .item .upload a.add:before, .content .report .item .upload a.add:after {
    content: " ";
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: #eaeaea;
}
.content .report .item .upload a.add:before {
    width: 2px;
    height: 26px;
}

.content .report .item .upload a.add:after {
    width: 26px;
    height: 2px;
}

.content .report .item .upload .tips {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 14px;
    color: #999;
    line-height: 18px;
}

.content .report .item .upload {
    overflow: hidden;
    position: relative;
    padding-bottom: 30px;
}

.content .report .item .code-img {
    display: inline-block;
    float: left;
    width: 100px;
    margin-left: 10px;
    height: 40px;
    background-size: contain;
    /* border: 1px solid #f2f2f2; */
    cursor: pointer;
}

a {
    text-decoration: none;
    color: #333;
    -webkit-transition: all .3s;
    transition: all .3s;
}

button {
    border: none;
    -webkit-transition: all .3s;
    transition: all .3s;
}

.content .report .submit button:hover {
    background-color: #198c2f;
}
</style>



// WEBPACK FOOTER //
// src/components/Complain_info.vue